import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { AuthenticationMethod } from 'views/UserProfile';

import Login from './Login';
import VerifyOTP from './VerifyOTP';
import history from '../../history';
import { setDeviceInfo } from '../../lib/auth';
import axios from '../../lib/axiosInstance';
import { loadLastReleaseNotesDate } from '../../views/Admin/ReleaseNotes/helper.js';

class Loginscreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      loginscreen: [],
      loginmessage: '',
      masked_email: '',
      verifyDevice: false,
      remember_me: false,
      mfa_method: AuthenticationMethod.Email,
    };
  }
  renderNotification() {
    return (
      <>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }
  async createDevice() {
    await setDeviceInfo(
      this.state.email,
      this.state.password,
      this.state.remember_me,
    )
      .then((data) => {
        let self = this;
        setTimeout(function () {
          self.setState({
            verifyDevice: true,
            mfa_method: data.mfa_method,
            masked_email: data.email,
          });
        }, 60);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async verifyOTPAndLoginUser() {
    let device_uid = localStorage.getItem('device_uid') || null;
    if (
      this.state.email &&
      this.state.password &&
      this.state.otp &&
      device_uid
    ) {
      let data = {
          username: this.state.email,
          password: this.state.password,
          remember_me: this.state.remember_me,
          otp_code: this.state.otp,
          device_id: device_uid,
        },
        url = '/api/token/';
      await axios
        .post(url, data)
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem('deviceVerified', true);
            localStorage.setItem('verified_at', new Date());
            if (res.data.is_admin === true) {
              localStorage.setItem(btoa('approle'), btoa('admin'));
            } else {
              localStorage.setItem(btoa('approle'), btoa('guest'));
            }
            localStorage.setItem('refresh', res.data.refresh);
            localStorage.setItem('access', res.data.access);
            localStorage.setItem('refreshTokenSetAt', new Date());
            localStorage.setItem('accessTokenSetAt', new Date());
            localStorage.setItem('loggedInUser', this.state.email);
            // after a successful login, load the last release notes date
            // it is required to render the left menu release notes item
            loadLastReleaseNotesDate().then((date) => {
              localStorage.setItem('releaseNoteLastReleaseDate', date);
            });
            history.push(
              '/' + atob(localStorage.getItem(btoa('approle'))) + '/dashboard',
            );
          } else {
            toast.error(
              'Authentication Failed! Please check your email address and password!',
            );
          }
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 401 || res.status === 400) {
            localStorage.removeItem('refresh');
            localStorage.removeItem('access');
            localStorage.removeItem('refreshTokenSetAt');
            localStorage.removeItem('accessTokenSetAt');
            toast.error('Authentication Failed! ' + res.data.detail);
          } else if (res.status === 200) {
            toast.warn('Authentication Failed! ' + res.data);
          }
        });
    }
  }

  setValue(key, value) {
    if (key) {
      if (key === 'remember_me') {
        let remember_me = this.state.remember_me;
        this.setState({ remember_me: !remember_me });
      } else {
        this.setState({ [key]: value });
      }
    }
  }
  redirectToLogin = () => {
    // redirect to loginscreen from verifyOTPScreen after 2 minutes if mfa_method is TOTP
    this.setState({ verifyDevice: false });
    toast.info('Your device session has been expired. Please login again!');
  };
  componentWillMount() {
    let loginscreen = [],
      verifyOTPScreen = [];
    let maintenanceMode = localStorage.getItem('maintenanceEnabled') === 'true';
    if (maintenanceMode) {
      history.push('/maintenance');
    }
    let verified_at = localStorage.getItem('verified_at');
    let accessToken = localStorage.getItem('access');
    if (
      accessToken &&
      accessToken.length > 0 &&
      verified_at &&
      verified_at !== undefined &&
      verified_at !== 'undefined'
    ) {
      history.push(
        '/' + atob(localStorage.getItem(btoa('approle'))) + '/dashboard',
      );
    }
    loginscreen.push(
      <Login
        parentContext={this}
        createDevice={this.createDevice.bind(this)}
        setValue={this.setValue.bind(this)}
        appContext={this.props.parentContext}
      />,
    );
    verifyOTPScreen.push(
      <VerifyOTP
        parentContext={this}
        setValue={this.setValue.bind(this)}
        appContext={this.props.parentContext}
        verifyOTP={this.verifyOTPAndLoginUser.bind(this)}
        resendOtp={this.createDevice.bind(this)}
      />,
    );
    var loginmessage = 'Not registered yet, Register Now';
    this.setState({
      loginscreen: loginscreen,
      verifyOTPScreen: verifyOTPScreen,
      loginmessage: loginmessage,
    });
  }
  componentDidMount() {
    let device_uid = localStorage.getItem('device_uid');
    if (device_uid === undefined || device_uid === '' || device_uid === null) {
      var dateObject = new Date();
      device_uid =
        dateObject.getFullYear() +
        '' +
        dateObject.getMonth() +
        '' +
        dateObject.getDate() +
        '' +
        dateObject.getTime();
      localStorage.setItem('device_uid', device_uid);
    }
  }

  screen() {
    if (this.state.verifyDevice === true) {
      return this.state.verifyOTPScreen;
    } else {
      return this.state.loginscreen;
    }
  }
  render() {
    return (
      <>
        <div className="loginscreen">{this.screen()}</div>
        {this.renderNotification()}
      </>
    );
  }
}

export default Loginscreen;
